/**
 * HistoryCard - Simulation history item card.
 */

import React from 'react';
import { Box, Typography, Chip, IconButton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { vortxTypography } from '@vortx/shared-ui';
import { COLORS } from './ResultsDesignTokens';

// History item
export const HistoryCard = ({ simulation, isActive, onLoad, onDelete }) => {
    const formatDate = (dateStr) => {
        try {
            const d = new Date(dateStr);
            return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
        } catch { return 'Unknown'; }
    };

    const efficiency = simulation.metadata?.efficiency_pct ?? simulation.result?.efficiency_pct;

    return (
        <Box
            onClick={() => onLoad(simulation)}
            sx={{
                p: 1.5,
                bgcolor: isActive ? alpha(COLORS.accent, 0.15) : COLORS.bg.card,
                border: `1px solid ${isActive ? COLORS.accent : 'rgba(255,255,255,0.05)'}`,
                borderRadius: 1,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                '&:hover': {
                    bgcolor: alpha(COLORS.accent, 0.1),
                    borderColor: alpha(COLORS.accent, 0.4),
                },
            }}
        >
            <Box sx={{
                width: 36,
                height: 36,
                borderRadius: 1,
                bgcolor: alpha(COLORS.accent, 0.2),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
            }}>
                <Typography sx={{
                    fontFamily: vortxTypography.mono,
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    color: COLORS.accent,
                }}>
                    #{simulation.topology?.id || '?'}
                </Typography>
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{
                    fontFamily: vortxTypography.mono,
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    color: COLORS.text.primary,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>
                    {simulation.topology?.name || 'Unknown'}
                </Typography>
                <Typography sx={{
                    fontFamily: vortxTypography.mono,
                    fontSize: '0.6rem',
                    color: COLORS.text.muted,
                }}>
                    {formatDate(simulation.timestamp)}
                </Typography>
            </Box>
            {efficiency != null && (
                <Chip
                    label={`${efficiency.toFixed(1)}%`}
                    size="small"
                    sx={{
                        height: 20,
                        fontFamily: vortxTypography.mono,
                        fontSize: '0.65rem',
                        fontWeight: 700,
                        bgcolor: alpha(COLORS.efficiency, 0.15),
                        color: COLORS.efficiency,
                        border: `1px solid ${alpha(COLORS.efficiency, 0.3)}`,
                    }}
                />
            )}
            <IconButton
                size="small"
                onClick={(e) => { e.stopPropagation(); onDelete(simulation.id); }}
                sx={{
                    color: COLORS.text.muted,
                    p: 0.5,
                    '&:hover': { color: COLORS.loss },
                }}
            >
                <DeleteIcon sx={{ fontSize: 14 }} />
            </IconButton>
        </Box>
    );
};
